import { render } from "./DesignBlock.vue?vue&type=template&id=713e4776&scoped=true"
import script from "./DesignBlock.vue?vue&type=script&lang=js"
export * from "./DesignBlock.vue?vue&type=script&lang=js"

import "./DesignBlock.vue?vue&type=style&index=0&id=713e4776&lang=scss&scoped=true"

import exportComponent from "/home/romych/projects/vue.home.zina.design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713e4776"]])

export default __exports__